import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CmsData, CmsDataHome, CmsDataInfo, CmsDataMap, CmsDataProject, CmsDataSettings, CmsDataDirections } from '../models/cmsdata';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  public cmsData: BehaviorSubject<CmsData> = new BehaviorSubject<CmsData>(undefined);
  public cmsDataErrorMessage: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public settings: BehaviorSubject<CmsDataSettings> = new BehaviorSubject<CmsDataSettings>(undefined);
  public home: BehaviorSubject<CmsDataHome> = new BehaviorSubject<CmsDataHome>(undefined);
  public info: BehaviorSubject<CmsDataInfo> = new BehaviorSubject<CmsDataInfo>(undefined);
  public map: BehaviorSubject<CmsDataMap> = new BehaviorSubject<CmsDataMap>(undefined);
  public projects: BehaviorSubject<CmsDataProject[]> = new BehaviorSubject<CmsDataProject[]>([]);
  public directions: BehaviorSubject<CmsDataDirections> = new BehaviorSubject<CmsDataDirections>(undefined);

  constructor(
    private http: HttpClient
  ) {

  }

  public loadCmsData() {
    this.cmsDataErrorMessage.next("")
    this.http.get<CmsData>(environment.cmsUrl+ (window.location.href.indexOf('localhost')> -1 ? '?v='+Math.random() : ''))
      .pipe(
        catchError((error: HttpErrorResponse) => {
          const errorMessage = `Unable to load CMS data. Error status: '${error.statusText}'. Error message: '${error.message}'`;
          console.error(errorMessage);
          this.cmsDataErrorMessage.next(errorMessage);
          return throwError(() => error);
        })
      )
      .subscribe((data) => {
        if (data) {
          this.customizeData(data);
          this.cmsData.next(data);
          this.settings.next(data.content.augment_2022_settings);
          this.home.next(data.content.augment_2022_home);
          this.info.next(data.content.augment_2022_info);
          this.map.next(data.content.augment_2022_map);
          this.projects.next(data.content.augment_2022_projects.projects);
          this.directions.next(data.content.augment_2022_directions);
        }
      });
  }

  /**
   * Customize data
   * - For phase1, override which markers are enabled.
   * @param data 
   */
  public customizeData(data: CmsData) {
    if (environment.envName === "phase1") {
      if (data.content.augment_2022_map?.markers) {
        data.content.augment_2022_map.markers.forEach((marker) => {
          marker.enabled = ["Arrow 2", "Arrow 3"].includes(marker.name)
        });
      }
    }
  }

}